import React, { FC } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';

import { ReactTable } from '@nhl/nhl-breakaway-ui';

import { Milestones } from '~/core/types';
import { commonMessages } from '~/utility/commonMessages';
import { ReactTableContainer } from '~/views/components/statsTable/styles';

import { MilestoneType } from '../enums';
import { HeaderContainer, NavLinkContainer, Section } from '../styles';

import { goalieColumnDefinitions, skaterColumnDefinitions } from './columnDefinitions';
import milestoneDefinitions from './milestoneDefinitions';

type MilestoneProps = {
    milestoneType: MilestoneType;
    milestoneData: Milestones;
};

const MilestoneTable: FC<MilestoneProps> = ({ milestoneType, milestoneData }) => {
    const intl = useIntl();

    const { header, isGoalie, linkText, linkUrl, sorted, column } = milestoneDefinitions(milestoneType);
    const { data } = milestoneData[milestoneType];

    return (
        <div>
            <Section $milestoneType={milestoneType}>
                <HeaderContainer>{intl.formatMessage(header)}</HeaderContainer>
                <NavLinkContainer>
                    <NavLink to={linkUrl}>{intl.formatMessage(linkText)}</NavLink>
                </NavLinkContainer>
            </Section>

            <ReactTableContainer>
                {data.length === 0 && (
                    <div className="rt-noData">
                        <FormattedMessage {...commonMessages.misc.noData} />
                    </div>
                )}
                <ReactTable
                    columns={
                        isGoalie
                            ? goalieColumnDefinitions(intl, column, header)
                            : skaterColumnDefinitions(intl, column, header)
                    }
                    data={data}
                    initialSorting={sorted}
                />
            </ReactTableContainer>
        </div>
    );
};

export default MilestoneTable;
